// import { z } from 'zod';

// const envSchema = z.object({
//     VITE_API_BASE_URL: z.string.("VITE_API_BASE_URL must be a valid URL"),
// });

const rawEnv = {
    // VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL || '',
    VITE_API_BASE_URL: 'https://app-defyedapi-dev-eastus-001.azurewebsites.net/api'
};

// const env = envSchema.parse(rawEnv);
const env = rawEnv;

export default env;
